import React from "react";

export function SourceBadge({ label }) {
  const map = {
    VERIFIED: {
      cls: "bg-[#E8F5E9] text-[#2E7D32] border border-[#2E7D32]/30",
      text: "Verified source",
    },
    NEEDS_VERIFICATION: {
      cls: "bg-[#FEF3C7] text-[#B45309] border border-[#D97706]/30",
      text: "Needs verification",
    },
    GENERAL_EDUCATIONAL: {
      cls: "bg-[#F1F5F9] text-[#334155] border border-[#475569]/30",
      text: "General educational",
    },
  };
  const meta = map[label] || map.GENERAL_EDUCATIONAL;
  return (
    <span
      data-testid={`source-badge-${label.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold tracking-wide ${meta.cls}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {meta.text}
    </span>
  );
}

export function UrgencyPill({ urgency }) {
  const cfg = {
    RED: "bg-red-50 text-red-700 border border-red-300",
    YELLOW: "bg-amber-50 text-amber-700 border border-amber-300",
    GREEN: "bg-emerald-50 text-emerald-700 border border-emerald-300",
  };
  return (
    <span
      data-testid={`urgency-${urgency.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold tracking-wide ${cfg[urgency] || cfg.GREEN}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      Urgency: {urgency}
    </span>
  );
}

export function Disclaimer({ children }) {
  return (
    <p
      data-testid="legal-disclaimer"
      className="text-xs text-[#4A525A] italic mt-3 border-l-2 border-[#C85A32]/40 pl-3"
    >
      {children ||
        "This is general educational information, not legal advice. DIYLegal.info is not a law firm. For advice about your specific situation, contact a licensed attorney or legal-aid organization."}
    </p>
  );
}
